import { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
    projectList,
    acceptInvitation,
    declineInvitation,
} from "slices/project";
import { getUserInvitations, logout } from "slices/user";
import { ROUTES } from "utils/constants";
import { getWalletBalance } from "slices/payment";
import { AppConfirm } from "components/app-confirm";

const ProjectHeader = (props) => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const { data, isInvitationAccepted, isInvitationDenied, } = useSelector((state) => state.projects);
    const { userInvitations } = useSelector((state) => state.user);
    const [projects, setProjects] = useState([]);
    const [selectedproject, setSelectedproject] = useState(null);
    const [invitedData, setInvitedData] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [modalText, setModalText] = useState("");
    const [modalShow, setModalShow] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [isAcceptOrDeny, setIsAcceptOrDeny] = useState(null);
    const [inviteModalSubTitle, setInviteModalSubTitle] = useState("")
    const [inviteModalTitle, setInviteModalTitle] = useState("")
    const [invitationProject, setInvitationProject] = useState([]);


    useEffect(() => {
        document.body.classList.add("loaded");
        document.body.classList.remove("dashboard-container");


        return () => {
            document.body.classList.add("dashboard-container");
            document.body.classList.remove("loaded");
        };
    }, []);

    useEffect(() => {
        setSelectedproject(null);
        dispatch(projectList());
        dispatch(getUserInvitations());
    }, [id, isInvitationAccepted, isInvitationDenied]);

    useEffect(() => {
        if (data.length > 0) {
            setSelectedproject(data.filter((item) => item.id == id)[0]);
            setProjects(data.filter((item) => item.id != id));
        }
    }, [data]);

    useEffect(() => {
        setInvitedData([]);
        if (userInvitations.length > 0) {
            const updatedList = userInvitations.map((item) => {
                return { ...item, isLoading: false };
            });
            setInvitedData(updatedList);
        }
    }, [userInvitations]);

    const navOnClick = (id) => {
        setSelectedproject(data.filter((item) => item.id == id)[0]);
        // if (selectedproject && selectedproject.owner) {
        //   setUserLinks((userLinksLi) => {
        //     return uniqueById([
        //       ...userLinksLi,
        //       {
        //         to: ROUTES.DELETE,
        //         label: "DELETE",
        //         img: "/assets/img/volume-dashboard/delete.svg",
        //       },
        //     ]);
        //   });
        // }
    };

    const { baseCurrency } = useSelector(
        (state) => state.user
    );
    const { currentBalance } = useSelector((state) => state.payment);

    useEffect(() => {
        dispatch(getWalletBalance());
    }, []);

    const userLogout = () => {
        setModalShow(true);
        setModalTitle("Logout");
        setModalText("Are you sure you want to log out? ");
    };

    const onConfirmLogoutClick = () => {
        dispatch(logout({ mode: "manual" }));
    }

    const onAcceptInvitation = (project) => {
        setIsAcceptOrDeny(1)
        setInvitationProject(project)
        setShowModal(true);
        setInviteModalSubTitle("Would you like to accept invitation for " + project?.projectName + "?")
        setInviteModalTitle("Confirm Accept Invitation")
    };

    const onRejectInvitation = (project) => {
        setIsAcceptOrDeny(0)
        setInvitationProject(project)
        setShowModal(true);
        setInviteModalSubTitle("Would you like to cancel invitation for " + project?.projectName + "?")
        setInviteModalTitle("Confirm Cancel Invitation")
    };

    const getButtonClick = (type, projectId) => {
        if (type === 1) {
            setIsAcceptOrDeny(null)
            dispatch(acceptInvitation({ id: projectId }));
            setShowModal(false);
        }
    };

    const onConfirmClick = () => {
        setIsAcceptOrDeny(null)
        dispatch(declineInvitation({ id: invitationProject.projectId }));
        setShowModal(false);
    };

    return (
        <>
            <div className="top-block">
                <div className="row align-items-center py-2">
                    <div className="col-md-6 selector-column">
                        <div className="project-selector d-sm-inline-block mb-1 mb-lg-0">
                            <span className="ptitle">Project</span>
                            <div className="dropdown d-inline-block">
                                {selectedproject &&
                                    (
                                        <button className="dropdown-toggle text-blue w-100" type="button"
                                            data-bs-toggle="dropdown" aria-expanded="false">
                                            <span className="me-2">
                                                {selectedproject.name}
                                            </span>
                                        </button>
                                    )}

                                <ul className="dropdown-menu mt-3 scrollable-dropdown">
                                    <li>
                                        <NavLink
                                            to={"/project"}
                                        >
                                            <div className="title-block mb-2 ">
                                                <span className="fs-13"><img src="/assets/images/icons/hexa-icon.svg" className="hex-icon"
                                                    alt="" />
                                                    {" "}  All Projects</span>
                                            </div>
                                        </NavLink>

                                    </li>
                                    <li>
                                        <div className="row">
                                            <div className="col-md-12 ">
                                                {projects.length > 0 &&
                                                    projects.map((item) => (
                                                        <div className="projects-listing" key={item.id}>
                                                            <NavLink
                                                                to={"/project/" + item.id + "/server"}
                                                                data-val={item.id}
                                                                onClick={(e) => navOnClick(item.id)}
                                                            >
                                                                {(item.owner) && <div className="row">
                                                                    <div className="col-sm-7">
                                                                        <div className="project-name-box">
                                                                            <img src="/assets/images/icons/4-dots-dark.svg"
                                                                                alt="" className="img-fluid" />
                                                                            <span className="pl-name"> {item.name}</span>
                                                                            {item.owner && (

                                                                                <span className="pl-status"> <img
                                                                                    src="/assets/images/icons/owner.svg"
                                                                                    alt="" className="img-fluid mb-1" />
                                                                                    {" "}OWNER</span>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-sm-5">
                                                                        <div className="project-members-box">
                                                                            <img src="/assets/images/icons/people.svg"
                                                                                alt="" className="img-fluid" />
                                                                            <span>{item.members > 1 ? "Members" : "Member"}</span>
                                                                            <span className="project-members-count">{item.members}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>}

                                                                {!(item.owner) && <div className="row">
                                                                    <div className="col-7">
                                                                        <div className="project-name-box">
                                                                            <img src="/assets/images/icons/4-dots-dark.svg"
                                                                                alt="" className="img-fluid" />
                                                                            <span className="pl-name"> {item.name}</span>
                                                                            {item.owner && (

                                                                                <span className="pl-status"> <img
                                                                                    src="/assets/images/icons/4-dots.svg"
                                                                                    alt="" className="img-fluid mb-1" />
                                                                                    {" "}OWNER</span>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-5">
                                                                        <div className="project-members-box">
                                                                            <img src="/assets/images/icons/people.svg"
                                                                                alt="" className="img-fluid" />
                                                                            <span>{item.members > 1 ? "Members" : "Member"}</span>
                                                                            <span className="project-members-count">{item.members}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>}
                                                            </NavLink>
                                                        </div>
                                                    ))}
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="project-selector project-invitations d-sm-inline-block mb-3 mb-md-0">
                            <div className="dropdown d-inline-block">
                                {invitedData.length > 0 ? (
                                    <button className="dropdown-toggle bg-transparent text-blue  w-auto fs-13" type="button"
                                        data-bs-toggle="dropdown" aria-expanded="false">
                                        <img src="/assets/images/icons/4-dots-dark.svg" className="hex-icon p-1" alt="" />
                                        {" "}Project Invitations
                                        <span className="invitation-count">{" "}{invitedData.length}</span>
                                    </button>
                                )
                                    :
                                    (
                                        <button className=" bg-transparent w-auto fs-13" type="button">
                                            <img src="/assets/images/icons/4-dots-dark.svg" className="hex-icon p-1" alt="" />
                                            {" "}Project Invitations <span className="invitation-count">{" "}{invitedData.length}</span>
                                        </button>
                                    )}
                                {invitedData.length > 0 && (
                                    <ul className="dropdown-menu mt-3 scrollable-dropdown">
                                        <NavLink
                                            to={"/project"}
                                        >
                                            <li>
                                                <div className="title-block mb-2 pt-2">
                                                    <span className="fs-13"><img src="/assets/images/icons/hexa-icon.svg" className="hex-icon "
                                                        alt="" /> Project Invitations</span>
                                                </div>
                                            </li>
                                        </NavLink>
                                        {invitedData.map((item, index) => (
                                            <li key={index}>
                                                {/* <NavLink
                                                    to={"/project"}
                                                > */}
                                                <div className="project-listing-single">
                                                    <div className="row align-items-center">
                                                        <div className="col-sm-8 pe-md-0">
                                                            <div className="d-flex align-items-center mb-1">
                                                                <img src="/assets/images/icons/icon-green-plus.svg"
                                                                    alt="" className="img-fluid me-1" />
                                                                <span className="project-name">{item.projectName}</span>
                                                            </div>
                                                            <div className="project-options">
                                                                <span className="user-name"><img
                                                                    src="/assets/images/icons/people.svg" alt=""
                                                                    className="img-fluid" /> {item.createdBy}</span>
                                                                <span className="date"> <img
                                                                    src="/assets/images/icons/calendar.svg"
                                                                    alt="" className="img-fluid" /> {item.createdDate} {item.createdTime}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-4 ps-sm-0 mt-2 mt-lg-0 text-sm-end">
                                                            <button
                                                                className="btn project-btn"
                                                                onClick={() => onRejectInvitation(item)}
                                                            >Reject</button>
                                                            <button
                                                                className="btn project-btn bg-blue"
                                                                onClick={() => onAcceptInvitation(item)}
                                                            >Accept
                                                                {" "}
                                                                {item.isLoading ? (
                                                                    <div
                                                                        className="spinner-border spinner-border-sm text-light"
                                                                        role="status"
                                                                    ></div>
                                                                ) : (
                                                                    ""
                                                                )}</button>
                                                        </div>
                                                    </div>

                                                </div>
                                                {/* </NavLink> */}
                                            </li>
                                        ))}
                                    </ul >
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-10 col-md-6 top-block-btns">
                        <span className="c-balance">
                            <p>CURRENT BALANCE : </p>
                            {" "}
                            {baseCurrency}{" "}
                            {currentBalance.toLocaleString(undefined, {
                                maximumFractionDigits: 6,
                            })}
                        </span>
                        <div className="top-btns-list">
                            <NavLink
                                to={"/" + ROUTES.PROJECT}
                                className="img-box" title="Projects">
                                <img src="/assets/images/icons/package-s-1.svg" alt="" />
                                <img src="/assets/images/icons/package-s-2.svg" alt="" />
                            </NavLink>
                            <NavLink
                                to={"/" + ROUTES.ACTIVITIES}
                                className="img-box" title="Activities">
                                <img src="/assets/images/icons/activities-s-1.svg" alt="" />
                                <img src="/assets/images/icons/activities-s-2.svg" alt="" />
                            </NavLink>
                            <NavLink
                                to={"/" + ROUTES.LIMITS}
                                className="img-box" title="Limits">
                                <img src="/assets/images/icons/limits-s-1.svg" alt="" />
                                <img src="/assets/images/icons/limits-s-2.svg" alt="" />
                            </NavLink>
                            {/* <a href="#" className="img-box">
                                    <img src="/assets/images/icons/support-s-1.svg" />
                                    <img src="/assets/images/icons/support-s-2.svg" />
                                </a> */}
                            <NavLink
                                to={"/" + ROUTES.ACCOUNT_SETTINGS}
                                className="img-box" title="Account Settings">
                                <img src="/assets/images/icons/account-s-1.svg" alt="" />
                                <img src="/assets/images/icons/account-s-2.svg" alt="" />
                            </NavLink>
                            <span className="img-box"
                                onClick={() => userLogout()}
                                title="Logout"
                            >
                                <img src="/assets/images/icons/log-out-s-1.svg" alt="" />
                                <img src="/assets/images/icons/log-out-s-2.svg" alt="" />
                            </span>
                        </div>

                    </div>

                </div>
            </div>

            <Outlet />

            <AppConfirm
                modaltitle={modalTitle}
                closeModal={false}
                modalsubtitle={modalText}
                onSubmit={onConfirmLogoutClick}
                size="md"
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
            <AppConfirm
                modaltitle={inviteModalTitle}
                modalsubtitle={inviteModalSubTitle}
                onSubmit={isAcceptOrDeny === 1 ? () => getButtonClick(1, invitationProject.projectId) : onConfirmClick}
                size="md"
                show={showModal}
                onHide={() => setShowModal(false)}
            />
        </>
    );
};

ProjectHeader.propTypes = {};

export default ProjectHeader;